import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { PaginatedTable, PaginatedTableCallbacks } from '../../common'
import { UnknownDepositTable } from './table'
import { JsonRecord, Record } from '../../../models'
import { getRecordsWithUnknownDeposit } from '../../../api'

export const RecordUnknownDepositComponent = () => {
    const [searchParams] = useSearchParams()

    const supplier_id = searchParams.get('supplier_id')
    const status = searchParams.get('status')

    return (
        <PaginatedTable<Record, JsonRecord>
            getData={(params) =>
                getRecordsWithUnknownDeposit({
                    ...params,
                    supplier_id,
                    status,
                })
            }
            modelConstructor={(json: JsonRecord) => new Record(json)}
            Table={(records: Record[], callbacks: PaginatedTableCallbacks) => (
                <UnknownDepositTable callbacks={callbacks} resources={{ records }} />
            )}
            searchPlaceholder="Search by Record ID, Agency, Last Name, Confirmation #"
            title={`Unknown Deposit Records for Supplier ${supplier_id}`}
        />
    )
}
